import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { CoreModule } from "../../core/core.module";
import { PipesModule } from "../../pipes/pipes.module";
import { SharedElementsModule } from "../../elements/shared/shared-elements.module";
import { GenericNotFoundComponent } from "./not-found/generic-not-found.component";
import { GenericOAuthRedirectCallbackComponent } from "./oauth/generic-oauth-redirect-callback.component";
import { UserUnsubscribeComponent } from "./unsubscribe/user-unsubscribe.component";
import { routing } from "./generic.routing";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        CoreModule,
        PipesModule,
        SharedElementsModule,
        routing,
        GenericNotFoundComponent,
        GenericOAuthRedirectCallbackComponent,
        UserUnsubscribeComponent,
    ],
    exports: [
        GenericNotFoundComponent,
        GenericOAuthRedirectCallbackComponent,
        UserUnsubscribeComponent,
    ],
})
export class GenericModule {}
